
/**
 * fft関数
 */
//一軸のスペクトルを得る
export function calcspectrum(arr,fromhead = false) {
    //2にべき乗データ数を補正(データ中央を使う)
    var cnt = Math.pow(2,Math.floor(Math.log2(arr.length)));
    if (fromhead) {
        var from = 0;
        var to = cnt;
    }else {
        var from = Math.ceil((arr.length-cnt)/2.0);
        var to = arr.length - Math.floor((arr.length-cnt)/2.0);
    }
    var a = arr.slice(from,to);
    var b = new Array(cnt).fill(0);
    //窓関数
    hanningwindow(a);
    //FFT
    FFT(a,b,cnt,false);
    //複素数の絶対値を求める
    var spc = a.map((value, idx)=>{
        return Math.hypot(a[idx],b[idx]);
    });
    //左右対称なので低いほう半分
    var spc = spc.slice(0,cnt/2);
    return spc;
}

//周波数配列を返す
export function hzarray(arr,rate)
{
    var hzarr = new Array(arr.length);
    var step = rate/(arr.length*2);
    for (var i = 0; i < hzarr.length; i++) {
        hzarr[i] = i * step;
    }
    return hzarr;
}

//FFT(2のべき乗個のデータ)
function FFT( an, bn, N, Inverse ){
    var ff = Inverse ? 1 : -1;
    var rot = new Array(N);
    for( var i = 0; i < rot.length; i++ ) rot[ i ] = 0;
    var nhalf = N/2, num = N/2;
    var sc = 2 * Math.PI / N;
    while( num >= 1 ){
        for(var j = 0; j < N; j += 2 * num ){
            var phi = rot[j] / 2;
            var phi0 = phi + nhalf;
            var c = Math.cos( sc * phi );
            var s = Math.sin( sc * phi * ff );
            for( var k = j; k < j + num; k++ ){
                var k1 = k + num;
                var a0 = an[ k1 ] * c - bn[ k1 ] *s;
                var b0 = an[ k1 ] * s + bn[ k1 ] *c;
                an[ k1 ] = an[ k ] - a0;
                bn[ k1 ] = bn[ k ] - b0;
                an[ k ] = an[ k ] + a0;
                bn[ k ] = bn[ k ] + b0;
                rot[ k ] = phi;
                rot[ k1 ] = phi0;
            }
        }
        num = num / 2;
    }
    for( var i = 0; i < N ; i++ ){
        var j = rot[ i ]; 
        if( j > i ){
            var tmp = an[ i ];
            an[ i ] = an[ j ];
            an[ j ] = tmp;
            var tmp = bn[ i ];
            bn[ i ] = bn[ j ];
            bn[ j ] = tmp;  
        }
    }
    for( var i = 0; i < N ; i++ ){
        an[ i ] = an[ i ] / Math.sqrt(N);
        bn[ i ] = bn[ i ] / Math.sqrt(N);
    }
}

//ハニングウインドウ&DCカット
function hanningwindow(an){
    var n = an.length;
    var ave = an.reduce((a, x) => a + x) / n;
    for( var i=0; i < n; i++ ){
        an[i] = an[i] - ave;
        an[i] = an[i]*0.5-0.5*Math.cos(2*Math.PI*((i+1)/n));
    }
}
